<template>
  <div class="head">
    <header>
      <div class="logo">
        <!-- <img src="@/assets/images/public/logo.png" alt> -->
        <!-- <div class="line"></div> -->
        <h1>康瑞杰工程</h1>
      </div>
      <div class="flex-row">
        <el-avatar class="mr10" v-show="userInfo.name">{{ userInfo.name }}</el-avatar>
        <!-- <div class="exit-btn" @click="handleExit">
          <img src="@/assets/images/public/exit.png" alt />
          <span>退出</span>
        </div> -->
      </div>
    </header>
  </div>
</template>

<script>
import { removeToken } from '@/utils/auth'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['userId','userInfo']),
  },
  mounted() {
    if(this.userId) {
      this.getUserInfo();
    }
  },
  watch: {
    "userId"(val) {
      if(val) {
        this.getUserInfo();
      }
    }
  },
  methods: {
    getUserInfo() {
      this.$http.get('/api/user/' + this.userId, {}).then(res => {
          if ( res.success) {
            var userInfo = res.data;
            this.$store.commit('demo/SET_USERINFO', userInfo);
          }
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.head {
  position: fixed;
  left: 0px;
  top: 0px;
  height: 60px;
  width: 100%;
  padding: 0px 22px;
  background-color: #070e35;
  z-index: 1999;
  .flex-row {
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
  }
  .mr10 {
    background-color: #0089FF;
    margin-right: 10px;
  }
  header {
    cursor: pointer;
    height: 60px;
    display: flex;
    justify-content: space-between;
  }
  .logo {
    display: flex;
    align-items: center;
  }
  .line {
    margin: 0px 15px;
    width: 1px;
    height: 34px;
    background-color: #fff;
  }
  h1 {
    color: #fff;
    font-size: 18px;
  }
  .exit-btn {
    cursor: pointer;
    height: 60px;
    display: flex;
    align-items: center;
    img {
      width: 20px;
      height: 22px;
    }
    span {
      padding-left: 8px;
      color: #fff;
    }
  }
}
</style>
